import { InputNumber } from 'antd';
import { t } from 'i18next';
import { numberFormatter } from 'src/utils/formatters';
import styled from 'styled-components';

export const NumberInput = styled(InputNumber).attrs({
  min: 15,
  max: 43200,
  formatter: (value) => numberFormatter(value),
  suffix: t('general.minutes'),
})`
  max-width: 180px;
  width: 100%;
`;
